/**
 *  This file is dedicated to define animations related to kyc form
 *  These animations are use GSAP package
 *  npm install gsap
 */
import gsap from "gsap";
export default {
  animations: {
    // Logo area related animations ---------------------------------------------------------------------
    beforeEnterLogoArea: function (element) {
      element.style.opacity = 0;
      //   element.style.transform = "translateY(-60px)";
    },

    enterLogoArea: function (element, done) {
      gsap.to(element, {
        opacity: 1,
        // y: 0,
        duration: 1,
        ease: "ease",
        onComplete: done,
      });
    },
    // Logo area related animations - ends ---------------------------------------------------------------

    // animation to fade from above ----------------------------------------------------------------------
    beforeEnterAbove: function (element) {
      element.style.opacity = 0;
      element.style.transform = "translateY(-30px)";
    },

    enterAbove: function (element, done) {
      gsap.to(element, {
        opacity: 1,
        y: 0,
        duration: 1,
        ease: "ease",
        onComplete: done,
      });
    },

    leaveAbove: function (element, done) {
      gsap.to(element, {
        opacity: 0,
        y: -30,
        duration: 1,
        ease: "ease",
        onComplete: done,
      });
    },

    // animation to fade from above end ----------------------------------------------------------------------

    // animation to fade  ------------------------------------------------------------------------------------
    beforeEnterFade: function (element) {
      element.style.opacity = 0;
    },

    enterFade: function (element, done) {
      gsap.to(element, {
        opacity: 1,
        duration: 1,
        ease: "power3.in",
        onComplete: done,
      });
    },

    leaveFade: function (element, done) {
      gsap.to(element, {
        opacity: 0,
        duration: 1,
        ease: "power3.in",
        onComplete: done,
      });
    },

    // animation to fade end ----------------------------------------------------------------------------

    // animation to fade from below ----------------------------------------------------------------------
    beforeEnterBelow: function (element) {
      element.style.opacity = 0;
      element.style.transform = "translateY(30px)";
    },

    enterBelow: function (element, done) {
      gsap.to(element, {
        opacity: 1,
        y: 0,
        duration: 1,
        ease: "power1.inOut",
        onComplete: done,
      });
    },

    leaveBelow: function (element, done) {
      gsap.to(element, {
        opacity: 0,
        y: 30,
        duration: 1,
        ease: "power1.inOut",
        onComplete: done,
      });
    },

    // animation to fade from below end ----------------------------------------------------------------------

    // Staggering animation-----------------------------------------------------------------------------------
    beforeEnterStaggering: function (element) {
      element.style.opacity = 0;
      element.style.transform = "translateY(100px)";
    },

    enterStaggering: function (element, done) {
      gsap.to(element, {
        opacity: 1,
        y: 0,
        duration: 0.8,
        onComplete: done,
        delay: element.dataset.index * 0.2,
      });
    },
    // Staggering animation end ------------------------------------------------------------------------------
  },
};
